const BASEURI = process.env.REACT_APP_BASE_URI || '';
const SCOUTURI = process.env.REACT_APP_SCOUT_URI || 'https://scout.agviewer.com';
const SCOUTAPIKEY = process.env.REACT_APP_SCOUT_API_KEY || 'TKLbJyfW.IMfhDLSn3VTW5t4x0otiYGwTiJj7oh4T';
let authFailureTriggered = false;
const AUTH_EXPIRED_EVENT = 'agviewer:auth-expired';
const AUTH_EXPIRED_WINDOW_FLAG = '__agviewer_auth_expired__';
const AUTH_TOKEN_ERROR_CODES = Object.freeze({
  MISSING: 'AUTH_TOKEN_MISSING',
  INVALID: 'AUTH_TOKEN_INVALID',
  EXPIRED: 'AUTH_TOKEN_EXPIRED',
  REFRESH_FAILED: 'AUTH_TOKEN_REFRESH_FAILED',
});

class AuthTokenError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'AuthTokenError';
    this.code = code;
    this.isAuthTokenError = true;
  }
}

function setAuthExpiredFlag(value) {
  if (typeof window !== 'undefined') {
    window[AUTH_EXPIRED_WINDOW_FLAG] = value;
  }
}

function isAuthTokenError(error) {
  return Boolean(error && error.isAuthTokenError);
}

function isAuthExpiredError(error) {
  return isAuthTokenError(error) && error.code === AUTH_TOKEN_ERROR_CODES.EXPIRED;
}

function handleAuthTokenError(error) {
  // Backward compatibility: some legacy chains still reject with token strings.
  if (typeof error === 'string') {
    return error;
  }

  if (isAuthTokenError(error)) {
    return false;
  }

  return Promise.reject(error);
}

var cookies = {
  getItem: function (sKey) {
    if (!sKey) { return null; }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          /*
          Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
          version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
          the end parameter might not work as expected. A possible solution might be to convert the the
          relative time to an absolute time. For instance, replacing the previous line with:
          */
          /*
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(vEnd * 1e3 + Date.now())).toUTCString();
          */
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
        default:
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) { return false; }
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};




function storageAvailable(type) {
  var storage;
  try {
    storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch (e) {
    return e instanceof DOMException && (
      // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0);
  }
}

function retrieveToken(name) {
  if (storageAvailable('localStorage')) {
    return localStorage.getItem(name);
  }
  else {

    console.log('localstorage not available');

    return cookies.getItem(name);


  }


}

function storeToken(name, value) {

  if (storageAvailable('localStorage')) {
    localStorage.setItem(name, value);
  }
  else {
    console.log('localstorage not available');
    cookies.setItem(name, value);

  }

}

function getNewToken(tokenType = 'token') {

  return new Promise((resolve, reject) => {

    var token;
    try {
      token = JSON.parse(retrieveToken(tokenType));
    } catch (error) {
      reject(false);
      return;
    }

    if (!token || typeof token.refresh !== 'string') {
      reject(false);
      return;
    }

    // console.log('getting new token');

    const url = BASEURI + '/api/token/refresh/';
    fetch(url,
      {
        method: 'POST',
        body: JSON.stringify({ refresh: token.refresh }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Token refresh failed: ${response.status}`);
        }
        return response.json();
      })
      .then((accessToken) => {

        if (!accessToken || typeof accessToken.access !== 'string') {
          reject(false);
          return;
        }

        token.access = accessToken.access;
        // console.log('storing new token and resolving true');
        storeToken(tokenType, JSON.stringify(token));

        resolve(true);

      })
      .catch(error => {
        // console.log('getting new token failed rejecting');
        return reject(error)
      });
  })

}

function parseJWT(token) {
  if (typeof token !== 'string') {
    return null;
  }

  let tokenParts = token.split('.');
  if (tokenParts.length < 2) {
    return null;
  }

  try {
    var base64Url = tokenParts[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jToken = JSON.parse(window.atob(base64));
    return jToken;
  } catch (error) {
    return null;
  }
}


function getAuthToken(tokenType = 'token') {


  return new Promise((resolve, reject) => {
    const failAuth = (code, message) => {
      const shouldTriggerAuthFailure =
        tokenType === 'token' &&
        code !== AUTH_TOKEN_ERROR_CODES.MISSING;

      if (shouldTriggerAuthFailure && !authFailureTriggered) {
        authFailureTriggered = true;
        handleAuthFailure();
      }
      reject(new AuthTokenError(code, message));
      return;
    };


    var token = retrieveToken(tokenType);

    if (!token) {
      reject(new AuthTokenError(
        AUTH_TOKEN_ERROR_CODES.MISSING,
        'Authentication token not found.'
      ));
      return;
    }


    try {
      token = JSON.parse(token);
    } catch (error) {
      failAuth(
        AUTH_TOKEN_ERROR_CODES.INVALID,
        'Authentication token is malformed.'
      );
      return;
    }

    //if somehow there is an auth token in localStorage 
    //but no access token
    if (!token || typeof token.access !== 'string') {
      failAuth(
        AUTH_TOKEN_ERROR_CODES.INVALID,
        'Authentication access token is missing.'
      );
      return;
    }


    var accessToken = parseJWT(token.access);
    if (!accessToken || !accessToken.exp) {
      failAuth(
        AUTH_TOKEN_ERROR_CODES.INVALID,
        'Authentication access token is invalid.'
      );
      return;
    }


    // console.log({
    //   tokenTime:new Date(accessToken.exp * 1000),
    //   tokenReduced: new Date((accessToken.exp -15) * 1000),
    //   now: new Date()
    //   });  

    if (new Date((accessToken.exp - 15) * 1000) < new Date()) {
      // console.log({
      //   isExpired: new Date((accessToken.exp - 15 )*1000) < new Date(),
      //   message: 'token expired'
      // });

      //if somehow there is an auth token in localStorage 
      //but no refresh token
      if (!token.refresh || typeof token.refresh !== 'string') {
        failAuth(
          AUTH_TOKEN_ERROR_CODES.EXPIRED,
          'Authentication session expired.'
        );
        return;
      }


      var refreshToken = parseJWT(token.refresh);
      if (!refreshToken || !refreshToken.exp) {
        failAuth(
          AUTH_TOKEN_ERROR_CODES.EXPIRED,
          'Authentication refresh token is invalid.'
        );
        return;
      }


      if (new Date((refreshToken.exp - 15) * 1000) < new Date()) {
        // console.log({
        //   isExpired: new Date((refreshToken.exp - 15)*1000) < new Date(),
        //   message: 'refresh token expired rejecting'
        // });
        failAuth(
          AUTH_TOKEN_ERROR_CODES.EXPIRED,
          'Authentication refresh token expired.'
        );
        return;
      }


      getNewToken(tokenType)
        .then(success => {
          token = retrieveToken(tokenType);
          try {
            token = JSON.parse(token);
          } catch (error) {
            failAuth(
              AUTH_TOKEN_ERROR_CODES.REFRESH_FAILED,
              'Authentication refresh response was invalid.'
            );
            return;
          }
          if (!token || typeof token.access !== 'string') {
            failAuth(
              AUTH_TOKEN_ERROR_CODES.REFRESH_FAILED,
              'Authentication refresh did not return access token.'
            );
            return;
          }
          // console.log('got new token');
          authFailureTriggered = false;
          setAuthExpiredFlag(false);
          resolve(token.access);
        })
        .catch(() => failAuth(
          AUTH_TOKEN_ERROR_CODES.REFRESH_FAILED,
          'Authentication refresh request failed.'
        ));

    } else {
      // console.log({
      //   isExpired: new Date((accessToken.exp - 15 )*1000) < new Date(),
      //   message: 'token valid rejecting'
      // });
      authFailureTriggered = false;
      setAuthExpiredFlag(false);
      resolve(token.access);
    }

  });


}

function flattenDictionaryNoSeparator(dict) {
  let flatDict = {};

  function helper(currentDict) {
    for (let key in currentDict) {
      if (currentDict.hasOwnProperty(key)) {
        if (typeof currentDict[key] === 'object' && currentDict[key] !== null && !Array.isArray(currentDict[key])) {
          helper(currentDict[key]);
        } else {
          flatDict[key] = currentDict[key];
        }
      }
    }
  }

  helper(dict);
  return flatDict;
}

function advancedFilter(value = '', items = [], setItems, searchableFields = []) {
  const normalizedItems = Array.isArray(items) ? items : [];
  const normalizedSearchableFields = Array.isArray(searchableFields) ? searchableFields : [];
  const applyItems = typeof setItems === 'function' ? setItems : () => { };

  // Process the input filter value: remove spaces and convert to lowercase
  const filterValue = String(value || '').toLowerCase().trim();
  let filtered = [];

  if (!filterValue.length) {
    applyItems(normalizedItems);
    return normalizedItems;
  }

  // Helper function to generate searchable text from the item
  const generateSearchableText = (item) => {
    if (!item || typeof item !== 'object') {
      return '';
    }

    const flattenDic = flattenDictionaryNoSeparator(item);
    return Object.entries(flattenDic)
      .filter(([key]) => normalizedSearchableFields.includes(key))
      .map(([, val]) => String(val).toLowerCase())
      .join(' ');
  };

  // Escape the filter value to safely use in a regular expression
  const escapedFilterValue = filterValue.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const filterRegex = new RegExp(escapedFilterValue, 'i');

  // Case 1: Try a whole-word match or partial word match
  filtered = normalizedItems.filter(item => {
    const searchableText = generateSearchableText(item).replace(/\s+/g, ' ');
    return filterRegex.test(searchableText); // Matches anywhere within the searchable text
  });

  // Case 2: If no matches, use a fallback strategy to match each character in sequence
  if (filtered.length < 1) {
    filtered = normalizedItems.filter(item => {
      const searchableText = generateSearchableText(item).replace(/\s+/g, '');
      let matchIndex = 0;

      for (const char of filterValue) {
        matchIndex = searchableText.indexOf(char, matchIndex);
        if (matchIndex === -1) return false;
        matchIndex += 1;
      }
      return true;
    });
  }

  // Set the filtered results
  applyItems(filtered);
  return filtered;
}




function formatDate(date) {
  date = new Date(date);
  let minutes = date.getMinutes(),
    hours = date.getHours(),
    dateString,
    day = date.getDate(),
    month = date.getMonth() + 1,
    year = date.getFullYear() % 2000;

  if (hours < 10)
    hours = '0' + hours;

  if (minutes < 10)
    minutes = '0' + minutes;

  if (day < 10)
    day = '0' + day;

  if (month < 10)
    month = '0' + month


  dateString = `${day}/${month}/${year} ${hours}:${minutes}`;

  return dateString;
}

function handleAuthFailure() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('adminOrOrgToken');
  } catch (error) { }

  setAuthExpiredFlag(true);

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  }
}

export {
  getAuthToken,
  formatDate,
  BASEURI,
  SCOUTURI,
  SCOUTAPIKEY,
  storeToken,
  retrieveToken,
  cookies,
  advancedFilter,
  handleAuthFailure,
  handleAuthTokenError,
  isAuthTokenError,
  isAuthExpiredError,
  AuthTokenError,
  AUTH_TOKEN_ERROR_CODES,
  AUTH_EXPIRED_EVENT,
  AUTH_EXPIRED_WINDOW_FLAG
};
